import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleUltimateGuide from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-ultimate-guide",
    element: <ArticleUltimateGuide />,
  },
  {
    path: "/cssbuy-vs-kakobuy-spreadsheet",
    element: <ArticleUltimateGuide />,
  },
  {
    path: "/cssbuy-spreadsheet-safety-guide",
    element: <ArticleUltimateGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;